import { supabase } from '@/supabase/client';

export type CopyEntry = {
  key: string;
  value: string;
};

export type CopyMap = Record<string, string>;

// site_copy is in the 'app' schema with 'val' column
const appSchema = supabase.schema('app');

export async function fetchCopyMap(): Promise<CopyMap> {
  const { data, error } = await appSchema.from('site_copy').select('key,val');
  if (error) throw error;
  const map: CopyMap = {};
  const rows = data as Array<{ key: string; val: string }> | null;
  for (const row of rows ?? []) {
    map[row.key] = row.val;
  }
  return map;
}

export async function upsertCopy(entries: CopyEntry[]): Promise<CopyEntry[] | null> {
  // Transform entries to use 'val' column name
  const dbEntries = entries.map(e => ({ key: e.key, val: e.value }));
  const { data, error } = await appSchema.from('site_copy').upsert(dbEntries, { onConflict: 'key' }).select();
  if (error) throw error;
  // Transform back to use 'value' for the returned type
  return (data as Array<{ key: string; val: string }> | null)?.map(row => ({
    key: row.key,
    value: row.val
  })) ?? null;
}
